"use client";

import Image from "next/image";

import { services } from "@/data/services";

import { AnimatedSection } from "../animated-section";
import CardService from "../card-service";
import HeaderSection from "../header-section";
import { MotionFadeIn } from "../motion-fade-in";

const ServicesSection = () => {
  return (
    <AnimatedSection>
      <section id="servicos" className="relative scroll-mt-20">
        <Image
          src="/paws.png"
          width={500}
          height={200}
          alt="paws"
          className="absolute -right-20 bottom-20 hidden h-auto w-auto rotate-60 object-contain opacity-5 md:block"
        />

        <div className="relative mx-auto max-w-7xl px-6 py-10 md:py-20 lg:px-16 xl:px-8">
          <HeaderSection
            title="Nossos Serviços"
            description="Saúde e bem-estar para seu pet."
            direction="center"
          />

          <div className="grid grid-cols-1 gap-8 pt-10 sm:grid-cols-2 lg:grid-cols-3">
            {services.map((service, index) => {
              return (
                <MotionFadeIn
                  direction="bottom"
                  delay={index * 0.1}
                  key={index}
                >
                  <CardService service={service} />
                </MotionFadeIn>
              );
            })}
          </div>
        </div>
      </section>
    </AnimatedSection>
  );
};

export default ServicesSection;
